import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { Navigation } from "./components/Navigation";
import { Home } from "./pages/Home";
import { CreatePO } from "./pages/CreatePO";
import { POList } from "./pages/POList";
import { VersionUpdates } from "./pages/VersionUpdates";

function App() {
	const { inProgress } = useMsal();

	return (
		<Router>
			<div className="min-h-screen bg-gray-50">
				<Navigation />

				{/* Loading State */}
				{inProgress === "startup" && (
					<div className="flex items-center justify-center h-64">
						<div className="text-center">
							<div className="inline-block animate-spin text-4xl mb-4">⏳</div>
							<p className="text-gray-600">Initializing...</p>
						</div>
					</div>
				)}

				{/* Routes */}
				{inProgress !== "startup" && (
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/create-po" element={<CreatePO />} />
						<Route path="/edit-po/:internalId" element={<CreatePO />} />
						<Route path="/po-list" element={<POList />} />
						<Route path="/version-updates" element={<VersionUpdates />} />
						<Route path="*" element={<Navigate to="/" replace />} />
					</Routes>
				)}
			</div>
		</Router>
	);
}

export default App;
